// extracted by mini-css-extract-plugin
export var faq = "faq-module--faq--3o_th";
export var colContainer = "faq-module--colContainer--3Wg-H";
export var qaCol = "faq-module--qaCol--wXx8a";
export var qaEntry = "faq-module--qaEntry--2FLSh";
export var qaContainer = "faq-module--qaContainer--1VPEm";
export var qaActiveEntry = "faq-module--qaActiveEntry--3C1Bl";